import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountLockoutComponentArgs } from '@modules/login/models/account-lockout-component-args';
import { CountdownComponent } from '@modules/common/components/countdown/countdown.component';
import { CompleteUrlBuilderService } from '@modules/common/services/complete-url-builder.service';

@Component({
    selector: 'app-login-account-lockout',
    templateUrl: './login-account-lockout.component.html',
    styleUrls: ['./login-account-lockout.component.scss']
})
export class LoginAccountLockoutComponent implements OnInit {
    @ViewChild(CountdownComponent, { static: true })
    public loginCountdownComponent!: CountdownComponent;

    public countdownCompleted = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        private readonly _args: AccountLockoutComponentArgs,
        private readonly _dialogRef: MatDialogRef<LoginAccountLockoutComponent>,
        private readonly _completeUrlBuilderService: CompleteUrlBuilderService,
    ) { }

    public ngOnInit(): void {
        this.loginCountdownComponent.countdownTo(this._args.lockedOutUntil);
    }

    public onCountdownCompleted(): void {
        this.countdownCompleted = true;
    }

    public closeDialog(): void {
        this._dialogRef.close();
    }

    public get passwordResetRoute(): string {
        return this._completeUrlBuilderService.buildUrl(['Login', 'ResetPassword']);
    }
}
